import { acatsAPIInstance } from "../api";

import {
  AcatsDtccTransferStatus,
  AcatsDtccTransferType,
  AcatsSortDirection,
  AcatsTransfer,
  AcatsTransferDirection,
  AcatsTransferStatus,
} from "./acats";

export interface ListAcatsTransfersParams {
  transfer_type?: AcatsDtccTransferType;
  transfer_direction?: AcatsTransferDirection;
  transfer_status?: AcatsTransferStatus;
  dtcc_status?: AcatsDtccTransferStatus;
  since?: string;
  until?: string;
  sort_direction?: AcatsSortDirection;
  limit?: number;
  page_token?: string;
}

export interface ListAcatsTransferResponse {
  transfers: AcatsTransfer[];
  pending_transfers?: number;
  page_token_next?: string;
  page_token_previous?: string;
}

export const listAcatsTransfers = async (
  params: ListAcatsTransfersParams
): Promise<ListAcatsTransferResponse> => {
  const res = await acatsAPIInstance.get<ListAcatsTransferResponse>("/acats", {
    params,
  });

  return res.data;
};
